import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';

const Verify2FA: React.FC = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const location = useLocation();
  const navigate = useNavigate();
  const { setAuthState } = useAuth();

  const query = new URLSearchParams(location.search);
  const userId = query.get('userId');
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleVerify2FA = async () => {
    try {
      console.log("userId:", userId);
      console.log("code:", code);
      const response = await axios.post<{ accessToken: string; refreshToken: string }>(`${apiUrl}/Auth/verify-2fa`, { userId, code });
      const { accessToken, refreshToken } = response.data;
      const email = localStorage.getItem('email'); // Retrieve email from localStorage
      setAuthState(accessToken, refreshToken, email ?? ''); // Set the authentication state
      navigate("/manager"); // Redirect to the appropriate page after successful verification
    } catch (error) {
      setError("Failed to verify 2FA code");
    }
  };

  return (
    <>
      <section className="reset-password-section">
   
        {error && <p style={{ color: "red" }}>{error}</p>}
        <div className='reset-password-form'>
          <input 
          className='reset-password-form__input'
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter 2FA code"
          />
         <div className='reset-form-button-section'>
         <button className='reset-password-form__button reset-password-form__button--primary' onClick={handleVerify2FA}>Verify</button>
         </div>
        </div>
      </section>
    </>
  );
};

export default Verify2FA;